import { render, staticRenderFns } from "./toma_muestras.vue?vue&type=template&id=464d8146"
import script from "./toma_muestras.vue?vue&type=script&lang=js"
export * from "./toma_muestras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports